export const enum ApartmentStatus {
  NotSet = "not_set",
  Unlocked = "unlocked",
  Locked = "locked",
}

export const enum IntercomWidgetVariant {
  Simple = "simple",
  Modern = "modern",
  Elite = "elite",
}

export const enum ControlSymbol {
  SUBMIT = "B",
  CLEAR = "C",
}
